import { render } from "./ChatInput.vue?vue&type=template&id=14768242&ts=true"
import script from "./ChatInput.vue?vue&type=script&lang=ts"
export * from "./ChatInput.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__